import { SlingoHTMLHelpProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/SlingoHTMLHelpProperties";
export class GameHTMLHelpProperties extends SlingoHTMLHelpProperties {
    setDefaultValues() {
        // define it all at the top level for convenience
        this.superSpinWheelElements = ["superspin", "superspinwheel", "superspingamble"];
        this.superSpinWheelMaxSpinElements = "help.slingo.standard.superspinwheel.line7";
        this.maxWinElements = []; // don't filter maxWinElements
        this.pendingGameElements = ["pending"];
        this.playControlsGameElements = ["controls"];
        this.extraSpinElements = ["help.slingo.standard.extraspins.line7"];
        this.availableWinElements = ["help.slingo.standard.extraspins.line5", "help.slingo.standard.extraspins.line6"];
    }
}
//# sourceMappingURL=GameHTMLHelpProperties.js.map